/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, createContext } from 'react';
import { auth, createUserProfileDocument } from '../firebase';

export const UserContext = createContext();

const UserProvider = ({ children }) => {
    const [state, setState] = useState({ user: null });

    let unsubscribeFromAuth = null;
    const { user } = state;

    async function FetchUsers() {
        try {
            unsubscribeFromAuth = auth.onAuthStateChanged(async (userAuth) => {
                if (userAuth) {
                    const userRef = await createUserProfileDocument(userAuth);
                    setState({ user: { ...userRef } });
                }

                setState({ user: userAuth });
            });
        } catch (error) {
            console.log('Error in UserProvider', error.message);
        }
    }
    useEffect(() => {
        FetchUsers();
        return () => {
            unsubscribeFromAuth();
        };
    }, []);

    return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

export default UserProvider;
